/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable dot-notation */
/* eslint-disable quotes */
/* eslint-disable no-nested-ternary */
/* eslint-disable prefer-destructuring */
/* eslint-disable import/namespace */

import React, { useEffect, useState, useRef } from 'react';
import ReactDOMServer from 'react-dom/server';
import { Menu, Button, ButtonGroup, Grid, FormGroup, FormControlLabel, Checkbox, Radio, RadioGroup, Backdrop, MenuItem, ListItemText, CircularProgress } from '@mui/material';
// @sudarsana for Optimize the Winflows 5 report generation time here we added the usePDF hook
// https://react-pdf.org/advanced#on-the-fly-rendering : @sudarsana based on that document we coded for usePDf code
import { usePDF } from '@react-pdf/renderer';
import axios from 'axios';
import { Canvg } from 'canvg';
import ArgoReport from '../ARGO_generate';
import ApexChartComponent from './apexchart';
import Invoice from '../pdf-report-generate';
import CreateGoogleSheet from './createGoogleSheet';
import CreateGoogleDoc from './createGoogleDoc';
import './pdf-options.scss';
import ExcelSheetFile from '../excel-sheet-create';
import { pdf, Sheets } from '../../shared/assets/images';
import { getArgoWordDoc } from '../../shared/api/url-helper';
import { check_CLRO_access, getUserDictData } from '../userData';
import { generateExcelWithImages } from "./generateExcelFile";
import jsontocsvConvertion from './jsontocsvConvertion';
import generateStandAloneArgoData from './generateStandAloneArgoData';
import SchematiDiagramSVG from '../edi-input/schematic-view-svg';
import ProductionSVG from '../ro-input/svg';
import { filterArgoRoPumps, getArgoElementModels } from '../ARGO_generate/utils/filterArgoRoPumps';
// @sudarsana Here we created new component for implemeting usePDF hook
const Createpdf = (props) => {
  const { flowSheetImage, pdfoption, report_invoice, ReportData, setFetchLoading, setPdfAnchorEl, setPdfButton, text, setPdfoption, options, setLoadingPdf, svgData, ReportRadio, setSubMenuAnchorEl, project_details, flowSheetSolvdData, setError } = props;
  // @kranthi : Added dynamic document node with error handling around PDF component creation
  let documentNode;
  try {
    documentNode = (ReportRadio === '1'
      ? <ArgoReport report_invoice={report_invoice} svgData={svgData} project_details={project_details} ReportData={ReportData} />
      : <Invoice flowSheetImage={flowSheetImage} report_invoice={report_invoice} pdfoption={pdfoption} flowSheetSolvdData={flowSheetSolvdData} />);
  } catch (err) {
    console.error('Error while preparing PDF document component', err);
    if (setError) { setError('Failed to prepare PDF content.'); }
  }
  const [instance] = usePDF({ document: documentNode });
  const handleClose = () => {
    setPdfAnchorEl(null);
    setSubMenuAnchorEl(null);
    setPdfoption(options);
  };
  useEffect(() => {
    try { // @kranthi : Wrapped PDF generation/download logic in try/catch
      if (instance && instance.url) {
        const link = document.createElement('a'); // @sudarsana creating anchor tag here after clicking generator button
        link.href = instance.url;
        link.setAttribute('download', `${text}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setFetchLoading(false);
        setPdfButton(false);
        setLoadingPdf(false);
        handleClose();
      }
    } catch (err) { // @kranthi : Error fallback for PDF generation
      console.error('Error during PDF generation/download', err);
      if (setError) { setError('Failed to generate PDF.'); }
      setFetchLoading(false);
      setPdfButton(false);
      setLoadingPdf(false);
      handleClose();
    }
  }, [instance]);
  return null;
};

// open menu when user click on pdf icon
// in that we can select option in which we can show in winflow report
function PdfOptions(props) {
  const { flowSheetImage, text, pdfOpen, setPdfAnchorEl, pdfAnchorEl, report_invoice, translateObject, flowSheetSolvdData } = props;
  // @kranthi : Safe extraction of report & argo data with nullish guards
  const ReportData = report_invoice?.report_dict || {};
  const ArgoinvoiceData = (ReportData && typeof ReportData.argo_report === 'object') ? (ReportData.argo_report || {}) : {};
  // const isShowReportData = ReportData && Object.keys(ReportData).length > 0;
  const StandAloneARGO = localStorage.getItem('StandAloneARGO') === 'true';
  // @kranthi : Hardened CLRO detection with defensive checks
  const checkDisabled = () => {
    try {
      const unitOutput = flowSheetSolvdData?.unitop_output;
      if (!unitOutput || typeof unitOutput !== 'object') { return false; }
      const dssroVal = Object.values(unitOutput).filter((ele) => { return ele && ele.unit_type === 'CLRO'; });
      return dssroVal.length > 0;
    } catch (err) {
      console.error('Error while checking DSSRO loop availability', err);
      return false; // fail safe
    }
  };
  const checkDSSRO = (data) => {
    const flag = data['RO/NF Unit ID'].find((ele) => {
      const value = ele?.toLowerCase?.();
      return value?.startsWith('ro') || value?.startsWith('nf');
    });
    if (flag) return true;
    return false;
  };
  const clroAccess = check_CLRO_access(getUserDictData(), 'CLRO User');
  // const ReportData = invoiceData.report_dict;
  // @kranthi : Helper for safe Object.keys length
  const safeLen = (obj) => { try { return obj && typeof obj === 'object' ? Object.keys(obj).length : 0; } catch { return 0; } };
  // @kranthi : Rewritten options array using safeLen to prevent runtime errors
  const options = [
    { label: 'Flowsheet Design Summary', disabled: safeLen(ReportData?.flowsheet_config_dict) > 0, checked: safeLen(ReportData?.flowsheet_config_dict) > 0 },
    { label: 'Feed-Product-Waste Summary', disabled: safeLen(ReportData?.feed_product_waste_summary) > 0, checked: safeLen(ReportData?.feed_product_waste_summary) > 0 },
    { label: 'RO/NF Unit System-Level Summary', disabled: safeLen(ReportData?.ro_hp) > 1 && safeLen(ReportData?.ro_summary) > 0, checked: safeLen(ReportData?.ro_hp) > 1 && safeLen(ReportData?.ro_summary) > 0 },
    { label: 'RO/NF Unit Stage-Level Summary', disabled: safeLen(ReportData?.ro_summary) > 0 && safeLen(ReportData?.ro_summary?.ro_stage_dict) > 0, checked: safeLen(ReportData?.ro_summary) > 0 && safeLen(ReportData?.ro_summary?.ro_stage_dict) > 0 },
    { label: 'RO/NF Aggregate Stream Summary', disabled: safeLen(ReportData?.ro_summary) > 0 && safeLen(ReportData?.ro_summary?.ro_stage_dict) > 0 && checkDSSRO(ReportData?.ro_summary?.ro_system_dict), checked: false },
    { label: 'EDI Unit System-Level Summary', disabled: safeLen(ReportData?.edi_summary) > 0, checked: safeLen(ReportData?.edi_summary) > 0 },
    { label: 'CF Unit Summary', disabled: safeLen(ReportData?.cf_summary) > 0, checked: safeLen(ReportData?.cf_summary) > 0 },
    { label: 'Chemical Dosing Unit Summary', disabled: safeLen(ReportData?.chem_dose_summary) > 0, checked: safeLen(ReportData?.chem_dose_summary) > 0 },
    { label: 'Antiscalant Dosage Summary', disabled: safeLen(ReportData?.argo_summary) > 0, checked: safeLen(ReportData?.argo_summary) > 0 },
    { label: 'ERD Unit Summary (WIP)', disabled: safeLen(ReportData?.erd_summary) > 0, checked: safeLen(ReportData?.erd_summary) > 0 },
    { label: 'Pump Unit Summary', disabled: safeLen(ReportData?.pump_summary) > 0, checked: safeLen(ReportData?.pump_summary) > 0 },
    { label: 'Stripper Unit Summary', disabled: safeLen(ReportData?.stripper_summary) > 0, checked: safeLen(ReportData?.stripper_summary) > 0 },
    { label: 'Mixer-Splitter Unit Summary', disabled: safeLen(ReportData?.mixer_summary) > 0, checked: safeLen(ReportData?.mixer_summary) > 0 },
    { label: 'Detailed RO/NF Element-Level Data', disabled: safeLen(ReportData?.ro_elem_summary) > 0, checked: false },
    { label: 'Detailed Stream Data', disabled: safeLen(ReportData?.stream_output) > 0, checked: safeLen(ReportData?.stream_output) > 0 },
    // { label: 'DSSRO Loop Summary', disabled: checkDisabled(), checked: false },
    { label: 'Notifications', disabled: Array.isArray(ReportData?.errors), checked: Array.isArray(ReportData?.errors) },
  ];

  if (clroAccess) {
    options.splice(5, 0, { label: 'DSSRO Section Summary', disabled: ReportData?.clro_elem_summary && ReportData.clro_elem_summary.clro_nos > 0, checked: ReportData.clro_elem_summary && ReportData.clro_elem_summary.clro_nos > 0 });
    options.splice(options.length - 1, 0, { label: 'DSSRO Loop Summary', disabled: checkDisabled(), checked: false });
  }
  const isArgoSummary = ReportData?.argo_report && Object.keys(ReportData.argo_report).length > 0 || StandAloneARGO;
  const isShowCLRO = ReportData?.clro_elem_summary && ReportData.clro_elem_summary.clro_nos > 0;
  const project_details = ReportData?.project_details || {};
  // creating an array that consist of option values in it.
  const canvasRef = useRef(null);
  const [argovalue, setArgoValue] = React.useState('');
  const [ArgoReportData, setArgoReportData] = useState({});
  // NEW: version counter to force re-run of ARGO init effect when custom event fires
  const [argoPayloadVersion, setArgoPayloadVersion] = useState(0);
  const [ReportRadio, setReportRadio] = useState('0');
  const [pdfoption, setPdfoption] = useState(options);
  const [error, setError] = useState(null); // @kranthi : Added central error state

  useEffect(() => {
    setPdfoption(options);
  }, [ReportData]);
  const [pdfButton, setPdfButton] = useState(false);
  const [ExcelButton, setExcelButton] = useState(false);
  const [DocButton, setDocButton] = useState(false);
  const [excelSheetFlag] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [loadingSheet, setLoadingSheet] = useState(false);
  const [loadingSpreadSheet, setLoadingSpreadSheet] = useState(false);
  const [subMenuAnchorEl, setSubMenuAnchorEl] = useState(null);
  const [, setSvgData] = useState('');
  const [imageSrc, setImageSrc] = useState('');
  const [createdSheetId, setCreatedSheetId] = useState(null);
  const sheetIdWaitResolveRef = useRef(null);
  // when we click on menu option
  // @kranthi : Guarded checkbox change handler
  const handleChange = (event) => {
    try {
      const newpdfoption = [...pdfoption];
      const specficoption = newpdfoption.find((val) => { return val.label === event.target.name; });
      if (specficoption) {
        specficoption.checked = event.target.checked; // adding checked value for specific selection vlaue
        setPdfoption(newpdfoption); // add that value to options
      }
    } catch (err) {
      console.error('Error updating PDF option selection', err);
      setError('Failed to update selection.');
    }
  };
  // NEW: listen for custom 'argoPayloadUpdated' event
  React.useEffect(() => {
    const handler = () => {
      setArgoPayloadVersion(v => v + 1);
    };
    window.addEventListener('argoPayloadUpdated', handler);
    return () => window.removeEventListener('argoPayloadUpdated', handler);
  }, []);

  // @kranthi : Initialize ARGO state safely (reruns when StandAloneARGO, ReportData, or argoPayloadVersion changes)
  useEffect(() => {
    try {
      const firstKey = Object.keys(ArgoinvoiceData || {})[0] || '';
      setArgoValue(firstKey);
      setArgoReportData(
        StandAloneARGO
          ? generateStandAloneArgoData({ invoiceData: ReportData?.argo_report })
          : ReportData?.argo_report?.[firstKey] ?? {}
      );
      setReportRadio(isArgoSummary ? '1' : '0');
    } catch (err) {
      console.error('Error initializing ARGO report data', err);
      setError('Failed to initialize ARGO data.');
    }
  }, [StandAloneARGO, ReportData, argoPayloadVersion]);
  useEffect(() => {
    setReportRadio(isArgoSummary ? '1' : '0');
  }, [isArgoSummary]);
  // @sudarsana here we updating the loading changes
  useEffect(() => {
    if (pdfButton) {
      setLoadingPdf(true);
    } else {
      setLoadingPdf(false);
    }

  }, [pdfButton]);
  const handledownloaded = (event) => {
    event.preventDefault();
    setLoadingPdf(true);
    setFetchLoading(true);
    setPdfButton(true);
  };
  const handlesheetdownload = (event) => {
    event.preventDefault();          // Prevent default form submission or link behavior
    // Set all loading states to true when download starts
    setLoadingSpreadSheet(true);
    setFetchLoading(true);
    setExcelButton(true);
    // After 2 seconds, reset all states back to false
    setTimeout(() => {
      setLoadingSpreadSheet(false);
      setFetchLoading(false);
      setExcelButton(false);
    }, 2000);
  };
  const getCLROImage = async () => {
    const data = report_invoice?.report_dict?.clro_schematic || {};
    const clro_schematic_data = [];
    const unitop_output = (() => {
      try {
        return JSON.parse(localStorage.getItem('ro_ouput_data') || '{}') || {};
      } catch {
        return {};
      }
    })();
    if (data && Object.keys(data).length > 0) {
      Object.keys(data).map((ele) => {
        const closedLoop = data[ele]['Prod Cycle'];
        const bringPurge = data[ele]['Brine Purge'];
        const unit = data[ele].units;
        const clro_captu = unitop_output?.[ele]?.output_user?.captu_ro;
        const closedLoopMarkup = ReactDOMServer.renderToStaticMarkup(
          <ProductionSVG loop='true' clro_captu={clro_captu} closedLoop={closedLoop} schmeticUnits={unit} />
        );
        const brinePurgeMarkup = ReactDOMServer.renderToStaticMarkup(
          <ProductionSVG loop='false' clro_captu={clro_captu} bringPurge={bringPurge} schmeticUnits={unit} />
        );
        clro_schematic_data.push({ svg: closedLoopMarkup, text: 'Production Loop', text1: `CL Sequence Duration - ${closedLoop['CL Sequence Duration'].toFixed(2)} min`, text2: `${ele} Schematic` });
        clro_schematic_data.push({ svg: brinePurgeMarkup, text: 'Brine Purge', text1: `BP Sequence Duration - ${bringPurge['BP Sequence Duration'].toFixed(2)} min`, text2: '' });
      });
    }
    const arr = await clro_schematic_data;
    const canvas = document.getElementById('myCanvas');
    if (canvas) canvas.remove();
    return arr;
  };
  const handleSheetCreated = async (sheetId) => {
    setLoadingSheet(true);
    setFetchLoading(true);
    // Normalize to { src, width, height } for the Excel generator
    const fsImg = (() => {
      if (typeof flowSheetImage === 'string') {
        return { src: flowSheetImage }; // data URL string
      }
      if (flowSheetImage && typeof flowSheetImage === 'object') {
        // if it's an <img> or canvas-like object
        const { src, width, height } = flowSheetImage;
        return src ? { src, width, height } : flowSheetImage;
      }
      return null;
    })();

    const diagramMap = {
      'Flowsheet Diagram': fsImg,
    };
    if (report_invoice.report_dict && report_invoice.report_dict.clro_schematic) {
      diagramMap['CLRO Schematic'] = await getCLROImage();
    }
    // Add EDI Schematic Diagrams from localStorage
    let ediDictData = localStorage.getItem('edi-dict');
    if (ediDictData) {
      try {
        ediDictData = JSON.parse(ediDictData);
        if (ediDictData.EDI) {
          Object.keys(ediDictData.EDI).forEach((ele) => {
            const ediDiagram = ReactDOMServer.renderToStaticMarkup(
              <SchematiDiagramSVG
                cocurrent={ediDictData.EDI[ele].co_current}
                ediDetails={{ id: ele }}
              />
            );
            const diagramKey = `${ele.toUpperCase()} - EDI Schematic`;
            diagramMap[diagramKey] = { svg: ediDiagram };
          });
        } else {
          // console.log('No EDI property found in ediDictData');
        }
      } catch (err) {
        console.error('Error parsing EDI dict data:', err);
      }
    } else {
      // console.log('No edi-dict found in localStorage');
    }
    report_invoice.report_dict.pdfoption = pdfoption;

    const checkDisabledDSSRO = () => {
      const dssroVal = Object.values(flowSheetSolvdData.unitop_output).filter((ele) => {
        return ele.unit_type === 'CLRO';
      });
      if (dssroVal.length > 0) {
        return dssroVal;
      }
      return {};
    };
    await generateExcelWithImages(
      jsontocsvConvertion(report_invoice.report_dict, checkDisabledDSSRO(), translateObject),
      diagramMap, text, translateObject
    );
    setLoadingSheet(false);
    setFetchLoading(false);
  };
  // @kranthi : Added comprehensive error handling for ARGO DOC generation
  const handledocdownload = (event) => {
    event.preventDefault();
    try {
      if (!ArgoinvoiceData) {
        throw new Error('No ARGO invoice data available.');
      }
      const ro_payload = JSON.parse(localStorage.getItem('ro_payload')) || '{}';
      const ro_dict = JSON.parse(localStorage.getItem('ro-dict')) || '{}';
      const argovaluedata = StandAloneARGO ? ArgoReportData : ArgoinvoiceData[argovalue] || {};
      const plantData = argovaluedata['Plant Data'] || {};
      const Treatment_and_Summary = argovaluedata['Treatment and Summary'] || {};
      const Water_Quality_Data = argovaluedata['Water Quality Data'] || {};
      const Calculation_Results = argovaluedata['Calculation Results'] || {};
      const Degrees_of_Saturation = argovaluedata['Degrees of Saturation'] || {};
      const argoRoPumpNames = filterArgoRoPumps(ro_payload.ro, Treatment_and_Summary['Selected Product']);
      const elementModels = getArgoElementModels(argoRoPumpNames, ro_dict);

      const data = {
        'Selected Product': Treatment_and_Summary['Selected Product'] || '-',
        'Required Dosage': argovaluedata['Required Dosage'] || '-',
        'Feed Flow': Treatment_and_Summary['Feed Flow'] || '-',
        'Brine Flow': Treatment_and_Summary['Brine Flow'] || '-',
        'Recovery': Treatment_and_Summary['Recovery'] || '-',
        'Feed Dosage': Treatment_and_Summary['Feed Dosage'] || '-',
        'Concentrate Dosage': Treatment_and_Summary['Conc Dosage'] || '-',
        'Membrane Manufacturer': 'Veolia',
        'Membrane Model Code': elementModels,
      };
      // Create the table data array dynamically from plantData
      const table_data_1 = Object.entries(plantData).map(([key, value]) => { // @kranthi : Safe mapping of plant data
        try {
          // Convert the value to a string if it's not already, and replace empty strings with "-"
          const stringValue = value !== undefined && value !== null ? value.toString() : '-';
          return [key, stringValue === '' ? '-' : stringValue];
        } catch (err) {
          console.error('Error processing plant data entry', key, err);
          return [key, '-'];
        }
      });

      const plantNameRow = table_data_1.find(item => item[0] === 'Plant Name');
      const plantTitle = plantNameRow ? plantNameRow[1] : 'Argo Analyzer';

      const rawFeed = Water_Quality_Data['RO Feed'] || {};
      const brine = Water_Quality_Data['Brine'] || {};

      // Insert the header row at the beginning
      const headerRow = ['Plant', 'Data'];
      table_data_1.unshift(headerRow);

      // Get common keys from both Raw Feed and Brine
      const commonKeys = Object.keys(rawFeed).filter(key => key in brine);
      // Construct the table data
      const table_data_2 = [
        ['Wat', ' Quality', ' Data', 'er'],
        ['Ion', 'RO Feed', 'Brine', 'Units'],
        ...commonKeys.map(key => { // @kranthi : Safe numeric formatting for water quality data
          const feedVal = rawFeed[key];
          const brineVal = brine[key];
          return [
            key,
            feedVal !== undefined && !Number.isNaN(parseFloat(feedVal)) ? parseFloat(feedVal).toFixed(2) : '-',
            brineVal !== undefined && !Number.isNaN(parseFloat(brineVal)) ? parseFloat(brineVal).toFixed(2) : '-',
            'ppm'
          ];
        })
      ];
      const percentOfMax = Calculation_Results['% of Max'] || {};
      const limits = Calculation_Results['Limits'] || {};
      const saturation = Calculation_Results['Saturation'] || {};
      const calciumCarbonate = Calculation_Results['Calcium Carbonate'] || {};
      // Collect all unique keys
      const keys = new Set([ // @kranthi : Unified key aggregation for calculation results
        ...Object.keys(percentOfMax),
        ...Object.keys(limits),
        ...Object.keys(saturation),
      ]);
      const caco3_Keys = Object.keys(calciumCarbonate);
      // Construct the table data
      const table_data_3 = [
        ['Calcula', 'on', ' Result', 'ti'],
        ['-', caco3_Keys?.[0] ?? '-', caco3_Keys?.[1] ?? '-', caco3_Keys?.[2] ?? '-'],
        ['Calcium Carbonate', JSON.stringify(calciumCarbonate?.[caco3_Keys?.[0]]) ?? '-', JSON.stringify(calciumCarbonate?.[caco3_Keys?.[1]]) ?? '-', calciumCarbonate?.[caco3_Keys?.[2]] ?? '-'],
        // ['-', 'S&DI', 'Limit', '-'],
        // [
        //   'Calcium Carbonate',
        //   calciumCarbonate.SDSI !== undefined ? calciumCarbonate.SDSI.toString() : '-',
        //   calciumCarbonate['Limit'] !== undefined ? calciumCarbonate['Limit'].toString() : '-',
        //   '-'
        // ],
        ['-', '𝗦𝗮𝘁𝘂𝗿𝗮𝘁𝗶𝗼𝗻', '𝗟𝗶𝗺𝗶𝘁', '% 𝗼𝗳 𝗠𝗮𝘅'],
        ...Array.from(keys).map(key => [
          key,
          saturation[key] !== undefined ? saturation[key].toString() : '-',
          limits[key] !== undefined ? limits[key].toString() : '-',
          percentOfMax[key] !== undefined ? percentOfMax[key].toString() : '-'
        ]),
      ];
      // Move CaHPO4 row to the specified position
      const caHPO4Index = table_data_3.findIndex(row => row[0] === 'CaHPO4');
      if (caHPO4Index !== -1) { // @kranthi : Re-ordered CaHPO4 row and inserted Brine Conc header
        try {
          const caHPO4Row = table_data_3.splice(caHPO4Index, 1)[0];
          table_data_3.splice(8, 0, caHPO4Row);  // Insert CaHPO4 row at index 8
          // Insert Brine Concentration row immediately after CaHPO4
          table_data_3.splice(9, 0, ['-', '𝗕𝗿𝗶𝗻𝗲 𝗖𝗼𝗻𝗰', '𝗟𝗶𝗺𝗶𝘁', '% 𝐨𝐟 𝐌𝐚𝐱']);
        } catch (err) {
          console.error('Error reordering CaHPO4 row', err);
        }
      }
      const noInhibitor = Degrees_of_Saturation['No Inhibitor'] || {};
      const withProduct = Degrees_of_Saturation[`With ${data['Selected Product']}`] || {};
      // Extract keys and values for table 4
      const keysoftable4 = Object.keys(noInhibitor);
      const keysoftable4_withProduct = Object.keys(withProduct);
      const values = keysoftable4.map(key => {
        const v = noInhibitor[key];
        return v !== undefined && !Number.isNaN(parseFloat(v)) ? parseFloat(v).toFixed(2) : '-';
      });
      const valuesWithProduct = keysoftable4_withProduct.map(key => {
        const v = withProduct[key];
        return v !== undefined && !Number.isNaN(parseFloat(v)) ? parseFloat(v).toFixed(2) : '-';
      });
      // Construct the table data for table 4
      const table_data_4 = [ // @kranthi : Build saturation tables with optional inhibitor row
        ['Saturation', ...keysoftable4],
        ['No Inhibitor', ...values],
      ];
      if (valuesWithProduct.length > 0) {
        table_data_4.push([`With ${data['Selected Product']}`, ...valuesWithProduct]);
      }
      const payload = {
        data,
        table_data_1,
        table_data_2,
        table_data_3,
        table_data_4,
        base64_image: imageSrc,
        title: plantTitle
      };
      setLoadingSheet(true);
      setFetchLoading(true);
      setDocButton(true);
      getArgoWordDoc(payload).then(response => { // @kranthi : Async doc generation + validation
        try {
          const docUrl = response?.data?.docUrl;
          setLoadingSheet(false);
          setFetchLoading(false);
          setDocButton(false);
          if (docUrl) {
            window.open(docUrl, '_blank');  // Open the URL in a new tab
          } else {
            throw new Error('Document URL not returned');
          }
        } catch (err) {
          console.error('Error handling document URL response', err);
          setError('Failed to open generated document.');
        }
      }).catch(error => {
        console.error('Error fetching the document URL:', error);
        setLoadingSheet(false);
        setFetchLoading(false);
        setDocButton(false);
        setError('Failed to generate document.');
      });
    } catch (err) {
      console.error('Unhandled error in handledocdownload', err);
      setError(err.message || 'Unexpected error while generating document.');
      setLoadingSheet(false);
      setFetchLoading(false);
      setDocButton(false);
    }
  };

  // when we click outside of menu it will collespe
  const handleClose = () => {
    setPdfAnchorEl(null);
  };
  // we can download report throught this fucntion
  // we are adjusting loaders throught this.
  // @kranthi : Switch between report modes (Winflows / ARGO)
  const handleChangeABFactor = (val) => {
    try {
      setReportRadio(val);
      const firstKey = Object.keys(ArgoinvoiceData || {})[0] || '';
      setArgoValue(firstKey);
      setArgoReportData(StandAloneARGO ? ReportData?.argo_report : ReportData?.argo_report?.[firstKey] ?? {});
    } catch (err) {
      console.error('Error changing report type (Winflows/ARGO)', err);
      setError('Failed to switch report mode.');
    }
  };
  const handleSubMenuOpen = (event, val) => {
    setSubMenuAnchorEl(event.currentTarget);
    handleChangeABFactor(val);
  };
  const handleSubMenuClose = () => {
    setSubMenuAnchorEl(null);
  };
  const canvasToImage = (canvasRef) => {
    return canvasRef.current.toDataURL('image/png');
  };
  // @kranthi : SVG to canvas rendering with error protection
  const drawSVGOnCanvas = (svgData, canvasRef) => {
    try {
      const ctx = canvasRef.current.getContext('2d');
      const v = Canvg.fromString(ctx, svgData);
      v.start();
    } catch (err) {
      console.error('Error drawing SVG on canvas', err);
      setError('Failed to process chart image.');
    }
  };
  const handleSvgData = (svg) => {
    setSvgData(svg);
    if (canvasRef.current) {
      drawSVGOnCanvas(svg, canvasRef);
      const imageData = canvasToImage(canvasRef);
      setImageSrc(imageData);
    }
  };
  // @kranthi : Change active ARGO scenario
  const handleChangeargo = (event) => {
    try {
      const val = event.target.value;
      setArgoValue(val);
      setArgoReportData(ArgoinvoiceData[val] || {});
    } catch (err) {
      console.error('Error updating selected ARGO scenario', err);
      setError('Failed to change ARGO selection.');
    }
  };
  // Data level validation effect
  // @kranthi : Data validation effect for incoming props
  useEffect(() => {
    try {
      if (!report_invoice) {
        setError('Report invoice data not provided.');
        return;
      }
      if (!report_invoice.report_dict || typeof report_invoice.report_dict !== 'object') {
        setError('Invalid report data structure.');
        return;
      }
      if (isArgoSummary && Object.keys(ArgoinvoiceData).length === 0) {
        setError('ARGO report summary expected but no data found.');
      }
      if (!flowSheetSolvdData || typeof flowSheetSolvdData !== 'object') {
        setError(prev => prev || 'Flowsheet solved data missing.');
      }
    } catch (err) {
      console.error('Error validating incoming data', err);
      setError('Unexpected error validating data.');
    }
  }, [report_invoice, flowSheetSolvdData, isArgoSummary]);
  return (
    <>
      {isArgoSummary && !StandAloneARGO && <Menu
        id="lock-menu"
        MenuListProps={{
          'aria-labelledby': 'pdf-report_data',
        }}
        onClose={handleClose}
        anchorEl={pdfAnchorEl}
        open={pdfOpen}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            maxWidth: '100vh',
            padding: '16px',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: '#F2F1F9',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {report_invoice?.report_dict?.flowsheet_config_dict && <MenuItem onClick={e => handleSubMenuOpen(e, '0')}>
          <ListItemText>{translateObject('Winflows Report')}</ListItemText>
        </MenuItem>}
        <MenuItem onClick={e => handleSubMenuOpen(e, '1')}>
          <ListItemText>{translateObject('ARGO Analyzer Report')}</ListItemText>
        </MenuItem>
      </Menu>}

      <Menu
        id="demo-positioned-menu"
        MenuListProps={{
          'aria-labelledby': 'lock-menu',
        }}
        anchorEl={isArgoSummary && !StandAloneARGO ? subMenuAnchorEl : pdfAnchorEl}
        keepMounted
        open={isArgoSummary && !StandAloneARGO ? Boolean(subMenuAnchorEl) : pdfOpen}
        onClose={isArgoSummary && !StandAloneARGO ? handleSubMenuClose : handleClose}
        sx={{ 'zIndex': 9999 }}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            maxWidth: ReportRadio === '0' ? '100vh' : '45vw',
            padding: '16px',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: '#F2F1F9',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <Grid container className='pdfOption' spacing={2} direction="row">
          {ReportRadio === '0' && <Grid container className='ButtonGroup'>
            <Grid item xs={12} md={5}>
              <div className='sansW6SeBld'><span>{translateObject('Generate')}</span><span style={{ fontWeight: 700 }}> {translateObject('Winflows Report')}</span></div>
            </Grid>
            {/* <Grid item xs={0.1} md={2}>{' '}</Grid> */}
            <Grid item xs={12} md={7} className='factor-wrapper'>
              <Grid container>
                <Grid item xs={12} md={4}>
                  <Button variant='contained' sx={{ 'backgroundColor': '#E0DDEE !important', 'border': 'none !important' }} className='Secondary-Default_button' onClick={handledownloaded} disabled={loadingPdf} startIcon={<img src={pdf} alt='share' className="menu-image" />}>
                    {loadingPdf ? (<CircularProgress color="inherit" size={15} disableShrink />) : (
                      <>{translateObject('PDF')}
                      </>
                    )}
                  </Button>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Button variant='contained' sx={{ 'backgroundColor': '#E0DDEE !important', 'border': 'none !important' }} className='Secondary-Default_button' onClick={handlesheetdownload} disabled={loadingSpreadSheet} startIcon={<img src={Sheets} alt='share' className="menu-image" />} >
                    {loadingSpreadSheet ? (<CircularProgress color="inherit" size={15} disableShrink />) : (
                      <>{translateObject('Sheets')}
                      </>
                    )}
                  </Button>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Button variant='contained' sx={{ 'backgroundColor': '#E0DDEE !important', 'border': 'none !important' }} className='Secondary-Default_button' onClick={handleSheetCreated} disabled={loadingSheet} startIcon={<img src={Sheets} alt='share' className="menu-image" />} >
                    {loadingSheet ? (<CircularProgress color="inherit" size={15} disableShrink />) : (
                      <>{translateObject('Excel')}
                      </>
                    )}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>}
          {ReportRadio === '1' && <Grid container className='ButtonGroup'>
            <Grid item xs={12} md={7.5}>
              <div className='sansW6SeBld'><span>{translateObject('Generate')}</span><span style={{ fontWeight: 700 }}> {translateObject('Argo Analyzer Report')}</span></div>
            </Grid>
            <Grid item xs={12} md={4} className='factor-wrapper'>
              <Grid container spacing={2}>
                <ButtonGroup variant="contained" aria-label="Basic button group" style={{ 'marginTop': '16px', 'marginLeft': '-20px', 'boxShadow': 'none' }}>
                  <Button variant='contained' sx={{ 'backgroundColor': '#E0DDEE !important', 'border': 'none !important' }} className='Secondary-Default_button' onClick={handledownloaded} disabled={loadingPdf} startIcon={<img src={pdf} alt='share' className="menu-image" />}>
                    {loadingPdf ? (<CircularProgress color="inherit" size={15} disableShrink />) : (
                      <>{translateObject('PDF')}
                      </>
                    )}
                  </Button>
                  <Button variant='contained' sx={{ 'backgroundColor': '#E0DDEE !important', 'border': 'none !important' }} className='Secondary-Default_button' onClick={handledocdownload} disabled={loadingSheet} startIcon={<img src={Sheets} alt='share' className="menu-image" />} >
                    {loadingSheet ? (<CircularProgress color="inherit" size={15} disableShrink />) : (<>{translateObject('Docs')}</>)}
                  </Button>
                </ButtonGroup>
              </Grid>
            </Grid>
          </Grid>}
          {excelSheetFlag && <ExcelSheetFile reportData={report_invoice} pdfoption={pdfoption} filename={text} />}
          {ExcelButton && <CreateGoogleSheet
            flowSheetImage={flowSheetImage}
            report_invoice={report_invoice}
            pdfoption={pdfoption}
            text={text}
            ro_summary={ReportData?.ro_summary}
            flowSheetSolvdData={flowSheetSolvdData}
            onSheetCreated={(id) => {
              setCreatedSheetId(id);
              // resolve any waiter
              if (sheetIdWaitResolveRef.current) {
                sheetIdWaitResolveRef.current(id);
                sheetIdWaitResolveRef.current = null;
              }
              // stop creation loaders
              setLoadingSheet(false);
              setFetchLoading(false);
              setExcelButton(false);
            }}
          />}
          {DocButton && <CreateGoogleDoc report_invoice={report_invoice} pdfoption={pdfoption} text={text} argovalue={argovalue} />}
          {/* @sudarsana here we are calling the componet CreatePdf and inside we are using usePDf hook */}
          {error && <div style={{ color: 'red', padding: '4px 12px', fontSize: 12 }}>{error}</div> /* @kranthi : Inline error display */}
          {pdfButton && (ReportRadio === '1' ? <Createpdf
            report_invoice={ArgoReportData} ReportData={ReportData} svgData={imageSrc} ReportRadio={ReportRadio} setFetchLoading={setFetchLoading} text={text} setSubMenuAnchorEl={setSubMenuAnchorEl} project_details={project_details} setPdfButton={setPdfButton} setPdfAnchorEl={setPdfAnchorEl} setPdfoption={setPdfoption} options={options} setLoadingPdf={setLoadingPdf} setError={setError}
          /> : <Createpdf
            flowSheetImage={flowSheetImage} report_invoice={report_invoice} pdfoption={pdfoption} setFetchLoading={setFetchLoading} text={text} setSubMenuAnchorEl={setSubMenuAnchorEl}
            setPdfButton={setPdfButton} setPdfAnchorEl={setPdfAnchorEl} setPdfoption={setPdfoption} options={options} setLoadingPdf={setLoadingPdf} flowSheetSolvdData={flowSheetSolvdData} setError={setError}
          />)}
        </Grid>
        {ReportRadio === '0' && <Grid container className='pdfOption2' spacing={2}>
          <Grid item xs={12} className='pdfOptinMenu' style={{ maxHeight: 200, overflow: 'auto', marginTop: 24, paddingTop: 0, paddingLeft: 0, marginLeft: 16 }}>
            <FormGroup row style={{ maxHeight: '60vh', flexDirection: 'column' }}>
              {fetchLoading && <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                style={{
                  background: '#d9dbde5c',
                }}
                open={fetchLoading}>
                <CircularProgress style={{ color: '#4b93f4' }} size={20} disableShrink />
              </Backdrop>}
              {pdfoption.map((value, index) => {
                return (<FormControlLabel key={index} control={<Checkbox checked={value.checked} onChange={handleChange}
                  disabled={!value.disabled} className='sansW4SeLig' sx={{
                    color: '#002D62',
                    '&.Mui-checked': {
                      color: '#002D62',
                    },
                  }}
                />} label={translateObject(value.label)} name={value.label} style={{ 'display': value.label === 'Notifications' ? 'none' : 'block' }} />);
              })}
            </FormGroup>
          </Grid>
        </Grid>}
        {ReportRadio === '1' && <div>
          <Grid container className='pdfOption2' spacing={2}>
            <Grid item xs={12} className='pdfOptinMenu' style={{ maxHeight: '200px', overflow: 'auto', marginTop: '24px', paddingTop: '0px' }}>
              <FormGroup row style={{ maxHeight: '60vh', flexDirection: 'row' }}>
                {fetchLoading && <Backdrop
                  sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                  style={{
                    background: '#d9dbde5c',
                  }}
                  open={fetchLoading}>
                  <CircularProgress style={{ color: '#4b93f4' }} size={20} disableShrink />
                </Backdrop>}
                {/* Show radio buttons only if not using standalone ARGO analyzer */}
                {!StandAloneARGO && <RadioGroup
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  style={{ flexDirection: 'row' }}
                  value={argovalue}
                  onChange={handleChangeargo}
                >
                  {Object.keys(ArgoinvoiceData || {}).map((value, index) => {
                    return (<FormControlLabel key={index} control={<Radio
                      className='sansW4SeLig' sx={{
                        color: '#002D62',
                        '&.Mui-checked': {
                          color: '#002D62',
                        },
                      }}
                    />} label={value} name={value} value={value} />);
                  })}
                </RadioGroup>}
              </FormGroup>
            </Grid>
          </Grid>
          <ApexChartComponent report_invoice={ArgoReportData} onSvgReady={handleSvgData} isShowCLRO={isShowCLRO} />
          <canvas ref={canvasRef} style={{ display: 'none' }} width="100" height="300" /></div>}
      </Menu>
    </>
  );
}

export default PdfOptions;
